// extracted by mini-css-extract-plugin
export default {"p_tye":"_909a51f4de","slcted":"_898185467d","slc_color":"_445cc1d9a9","item_p":"_6fe9a6ce69","r0":"c37921b66e"};